<template>
  <div class="style-general">
    <transition name="slide" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/Root.vue